import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ObjectStoreService } from 'src/app/acl-data/object-store/object-store.service';

@Component({
  templateUrl: './demo-content.component.html',
  styleUrls: ['./demo-content.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemoContentComponent {
  constructor(private objectStore: ObjectStoreService) {}
}
